module.exports = __webpack_public_path__ + "img/mission-1.6a234a12.png";